module.exports = __webpack_public_path__ + "static/media/banner2.a5d61924.jpg";